// @vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const { recordLink } = require('utilities/tagging');

// @components
const { HireInformation } = require('components/hire/hireInformation/hireInformation');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');
const ContactCenterValidationCards = require('components/hire/contactCenterValidationCards/contactCenterValidationCards');

//@commons
const { OKLink } = require('commonsComponents/OKLink');

// @constants
const { PROC_CARD_VIRTUAL_CREDIT } = require('utilities/tagging');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { FIRST_STEP } = require('constants/index');

// @constants
const { VIRTUAL_CREDIT_CARD_PRODUCT_ALIAS,
    PRODUCT_HIRING_COMPONENT_ID } = require('constants/hiringProductInformation');
const { GC, CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');

class HireCardVirtualCreditStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.onClickTealium = this.onClickTealium.bind(this);
    }

    componentDidMount() {
        const {
            flagBasedFeatures,
            requestPDFMerge,
            setTermsAndCondsText,
        } = this.props;

        if (!__CONTACT_CENTER__) {
            const pdfurls = getCardsPreContractPdfData()['virtual_credit'].preContractPdfLink;
            const product = {
                type: '500',
                subtype: '803',
                standard: '0000001'
            };
            const showIneAndRevolving = flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
            if (!showIneAndRevolving) {
                requestPDFMerge(pdfurls, [product]);
            }
        } else {
            const termsAndConsText = [
                formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxText1'),
                formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkText1'),
                formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxText2'),
                formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkText2'),
                formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxText3'),
            ];

            setTermsAndCondsText(termsAndConsText.join(' '));
        }
    }

    onClickTealium(translateKey) {
        recordLink(PROC_CARD_VIRTUAL_CREDIT, formatText(translateKey));
    }

    buildLegalConfirmationSection() {
        const { showIneAndRevolving } = this.props;
        if (!__CONTACT_CENTER__ || showIneAndRevolving) return null;

        const {
            contractName,
            handleAgreementCheckboxChange,
            immHireCardVirtualCredit,
            sendMailParams,
        } = this.props;

        const immStep = immHireCardVirtualCredit.getIn(['steps', FIRST_STEP]);
        const agreementErrorMsg = formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxErrorMsg');

        // Re-uses step 3 labels because they need to be the same as in step 3 but moved to step 1
        const agreementLinkUrl1 = formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkUrl1');
        const agreementLinkUrl2 = formatText('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkUrl2');

        const agreementLabel = (
            <React.Fragment>
                <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxText1" />
                &nbsp;
                <OKLink
                    modifier="emphasize"
                    onClick={() => this.onClickTealium('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkText1')}
                    target="_blank"
                    to={agreementLinkUrl1}
                >
                    <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkText1" />
                </OKLink>
                &nbsp;
                <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxText2" />
                &nbsp;
                <OKLink
                    modifier="emphasize"
                    onClick={() => this.onClickTealium('hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkText2')}
                    target="_blank"
                    to={agreementLinkUrl2}
                >
                    <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxTextLinkText2" />
                </OKLink>
                &nbsp;
                <FormattedText value="hireCardVirtualCredit-hireCardVirtualCredit_step3CheckboxText3" />
            </React.Fragment>
        );

        return (
            <ContactCenterValidationCards
                agreementErrorMsg={agreementErrorMsg}
                agreementLabel={agreementLabel}
                contractName={contractName}
                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                immStep={immStep}
                sendMailParams={sendMailParams}
            />
        );
    }

    render() {
        const { hireCmsKey, immHireInformation, gestorCrossEnabled, flagBasedFeatures } = this.props;
        const legalConfirmationSection = this.buildLegalConfirmationSection();
        let productInformationComponent;
        if (gestorCrossEnabled && flagBasedFeatures.get(GC)) {
            productInformationComponent = (
                <React.Fragment>
                    <HiringProductInformation
                        productAlias={VIRTUAL_CREDIT_CARD_PRODUCT_ALIAS}
                        productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                    />
                    {legalConfirmationSection}
                </React.Fragment>
            )
        } else {
            productInformationComponent = (
                <article className="hire-card-virtual-credit__step-one">
                    <FormattedText
                        className="hire-card-virtual-credit__step-title"
                        value="hireCardVirtualCredit-hireCardVirtualCredit_step1Title"
                    />
                    <HireInformation
                        hireCmsKey={hireCmsKey}
                        immHireInformation={immHireInformation}
                        tealiumProcess={PROC_CARD_VIRTUAL_CREDIT}
                    />
                    {legalConfirmationSection}
                </article>
            )
        }
        return (
            <div>
                {productInformationComponent}
            </div>
        );
    }
}

HireCardVirtualCreditStep1.propTypes = {
    contractName: PropTypes.string.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    handleAgreementCheckboxChange: PropTypes.func.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    hireCmsKey: PropTypes.string.isRequired,
    immHireCardVirtualCredit: PropTypes.object.isRequired,
    immHireInformation: PropTypes.object.isRequired,
    requestPDFMerge: PropTypes.func.isRequired,
    sendMailParams: PropTypes.object.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    showIneAndRevolving: PropTypes.bool,
};

module.exports = HireCardVirtualCreditStep1;
